import React from 'react'
import { DisplayErrorProps } from '../../services/lib/types'
import './ICSErrorCard.css'
import { Alert } from 'reactstrap'

const ICSErrorCard = ({
  code,
  message,
  fields = [],
  title = 'API Response Error',
}: DisplayErrorProps) => {
  return (
    <Alert color='danger' className='ics-error-card'>
      <h4 style={{textAlign:'center',margin:'0px'}}>{title}</h4>
      <div style={{display:'flex',justifyContent:'center'}} className='ics-error-item'>
        {message}
      </div>
      {fields.length > 0 && (
        <>
          <hr style={{margin:'7px 0px'}} />
          <div style={{display:'flex',justifyContent:'center'}} className='ics-error-item'>
              {fields.map((fieldError, index) => (
                <div  key={index}>
                  <p style={{margin:'0px',lineHeight:'revert'}} className='badge badge-danger'>{fieldError.field ? fieldError.field : fieldError}</p>
                  {fieldError.message && `: ${fieldError.message}`}
                </div>
              ))}
          </div>
        </>
      )}
    </Alert>
  )
}

export default ICSErrorCard
